module.exports = "<div class=\"toolTip {{align}}\" ng-class=\"{'displayInline': displayInline, 'balloon': !displayInline}\" ng-transclude role=\"tooltip\" id=\"{{toolTipID}}\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-ui-components/src/tooltip/template.html
// module id = ../node_modules/xo-ui-components/src/tooltip/template.html
// module chunks = 0